<template>
  <main class="about">
    <div class="about__hello">
      <div class="about__hello__hey subtitle"><div>Hello</div></div>
      <div class="about__hello__photo">
        <div class="about__hello__photo__container"><video src="/Jean.mp4" playsinline autoplay loop muted></video></div>
      </div>
      <div class="about__hello__notMe subtitle"><div>(that's not me)</div></div>
      <div class="about__hello__frenchTouch title"><div>{{ cutTitle('french touch') }}</div></div>
      <div class="about__hello__presentation paragraph">
        <p>Hey, I’m a Paris based Digital Designer, currently working at Source Interactive as a Product Designer. During my spare time I love to discover random things such as new musics, movies, comics or expositions. I also like to design things (sometimes). </p>
      </div>
    </div>
    <div class="about__me">
      <div class="about__me__items">
        <div class="subtitle">Experiences</div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Viens-là – Art Director</div>
          <div class="about__me__items__single__subtitle">July to December 2019 | Paris</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Unit9 - UX Designer</div>
          <div class="about__me__items__single__subtitle">July to October 2018 | London</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Freelance Digital Designer</div>
          <div class="about__me__items__single__subtitle">Since 2018 | Anywhere</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">HETIC - Student</div>
          <div class="about__me__items__single__subtitle">2015 to 2020 | Paris</div>
        </div>
      </div>
      <div class="about__me__items">
        <div class="subtitle">Skills</div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Art direction</div>
          <div class="about__me__items__single__subtitle">I like to imagine stuff</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">UI/UX Design</div>
          <div class="about__me__items__single__subtitle">I like to design stuff</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Motion Design</div>
          <div class="about__me__items__single__subtitle">I like to move stuff</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Front-end Development</div>
          <div class="about__me__items__single__subtitle">I like to code stuff. Sometimes</div>
        </div>
      </div>
      <div class="about__me__items">
        <div class="subtitle">Hobbies</div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Music</div>
          <div class="about__me__items__single__link"><a href="https://open.spotify.com/user/aractann/playlist/09KjTzuxbjSYQ1sK12iC33?si=QDmYpsUwTb2yzIlvp_GAzA" rel="noreferrer" target="_blank">Check out my spotify playlist</a></div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Cinema</div>
          <div class="about__me__items__single__subtitle">Who would've thought?</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Comics</div>
          <div class="about__me__items__single__subtitle">Team Captain all the way</div>
        </div>
        <div class="about__me__items__single">
          <div class="about__me__items__single__content">Video Games</div>
          <div class="about__me__items__single__subtitle">See me in Smash bros</div>
        </div>
      </div>
    </div>
    <div class="about__contact">
      <div class="subtitle">Contact</div>
      <div class="about__contact__paragraph paragraph">
        <p>Interested in my work ? Feel free to contact me at theo.grandin74[at]gmail.com</p>
        <p>I’ll be happy to talk with you!</p>
      </div>
    </div>
    <footer class="socials">
      <a href="https://twitter.com/Theo_grand1" rel="noreferrer" target="_blank" class="paragraph">twitter</a>
      <a href="https://dribbble.com/Theo_Grandin" rel="noreferrer" target="_blank" class="paragraph">dribbble</a>
      <a href="https://www.linkedin.com/in/theo-grandin/" rel="noreferrer" target="_blank" class="paragraph">linkedin</a>
      <label class="paragraph" @click="copy" for="mailCopy">
        email
        <span class="mailCTA">Click to copy mail to clipboard</span>
      </label>
    </footer>
    <textarea id="mailCopy" readonly></textarea>
  </main>
</template>

<script>
export default {
  data () {
    return {
      sceneHeight: 0,
      lineHeight: 0
    }
  },
  mounted () {
    this.sceneHeight = document.querySelector('.about__hello__photo__container video').offsetHeight
    document.querySelector('.about__hello__photo__container').style.transform = 'translateX(' + this.sceneHeight + 'px)'
    document.querySelector('body').style.overflowY = 'scroll'
    this.transitionEnter()
  },

  methods: {
    copy () {
      const text = document.querySelector('textarea')
      const mailCTA = document.querySelector('.mailCTA')
      text.value = 'theo.grandin74@gmail.com'
      text.select()
      document.execCommand('copy')
      mailCTA.innerHTML = 'Copied!'
    },

    transitionEnter () {
      setTimeout(() => {
        document.querySelector('.about__hello__photo__container').style.transition = 'transform 1.15s cubic-bezier(0.86,-0.06, 0.23, 0.99)'
        document.querySelector('.about__hello__photo__container').style.transform = 'translateX(0)'
        document.querySelector('.about__hello__hey').style.opacity = 0.4
        document.querySelector('.about__hello__notMe').style.opacity = 0.4
        document.querySelector('.about__hello__presentation').style.opacity = 1
      }, 50)
    },

    transitionLeave () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.transitionTitleLeave()
      document.querySelector('.about__hello__photo__container').style.transform = 'translateX(-' + this.sceneHeight + 'px)'
      document.querySelector('.about__hello__hey').style.opacity = 0
      document.querySelector('.about__hello__notMe').style.opacity = 0
      document.querySelector('.about__hello__presentation').style.opacity = 0
    },

    transitionTitleEnter () {
      let spans = document.querySelectorAll('.title span')
      for (let i = 0; i < spans.length; i++) {
        spans[i].style.transform = 'translateY(160px)'
        spans[i].style.transition = 'all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99)'
        spans[i].style.transitionDelay = 0.03 * i + 's'
      }
      setTimeout(() => {
        for (let i = 0; i < spans.length; i++) {
          spans[i].style.transform = 'translateY(0px)'
        }
      }, 10)
    },

    transitionTitleLeave () {
      let spans = document.querySelectorAll('.title span')
      for (let i = 0; i < spans.length; i++) {
        spans[i].style.transitionDelay = 0.03 * i + 's'
        spans[i].style.transform = 'translateY(160px)'
      }
    },

    cutTitle (title) {
      this.$nextTick(() => {
        let children
        for (let i = 0; i < title.length; i += 1) {
          const span = document.createElement('span')
          if (title[i] === ' ') {
            children = '\u00A0'
          } else {
            children = title[i]
          }
          span.style.display = 'inline-block'
          span.style.transition = 'all 1s cubic-bezier(0.86,-0.06, 0.23, 0.99)'
          span.append(children)
          document.querySelector('.title div').append(span)
        }
        this.transitionTitleEnter()
      })
    }
  },

  beforeRouteLeave (to, from, next) {
    this.transitionLeave()
    setTimeout(() => {
      next()
    }, 1150)
  }
}
</script>

<style lang="scss" scoped>
// responsive
$phone:640px;
$tablet: 768px;
$desktop: 1024px;
$large: 1680px;

.about
{
  position: relative;

  &__hello
  {
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: 70px calc(100vh / 1.5) 64px 1fr 70px;
    grid-template-rows: 1fr calc(100vh/3) calc(100vh/3) 1fr;

    @media screen and (max-width: $phone) and (orientation: portrait)
    {
      height: 100%;
      grid-template-columns: 1fr calc(100vw - 80px) 1fr;
      grid-template-rows: 120px calc(100vw - 80px) 8px 24px 1fr;
    }

    &__photo
    {
      grid-column-start: 2;
      grid-column-end: 3;
      grid-row-start: 2;
      grid-row-end: 4;
      border-radius: calc(100vh/15);
      overflow: hidden;

      @media screen and (max-width: $phone) {
        grid-row-end: 3;
        border-radius: calc((100vw - 80px) / 10);
      }

      &__container
      {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: calc(100vh/15);
        -webkit-mask-image: -webkit-radial-gradient(white, black);

        @media screen and (max-width: $phone) {
          border-radius: calc((100vw - 80px) / 10);
        }

        video
        {
          width: auto;
          height: 100%;
        }
      }
    }

    &__hey
    {
      grid-column-start: 2;
      grid-column-end: 3;
      display: flex;
      align-items: flex-end;
      opacity: 0;
      transition: opacity 1.15s cubic-bezier(0.86,-0.06, 0.23, 0.99);

      div
      {
        margin-left: calc(100vh/15);
        margin-bottom: 16px;

          @media screen and (max-width: $phone) and (orientation: portrait)
          {
            margin-bottom: 8px;
            margin-left: calc((100vw - 80px) / 10);
          }
      }
    }

    &__notMe
    {
      grid-column-start: 2;
      grid-column-end: 3;
      display: flex;
      justify-content: flex-end;
      opacity: 0;
      transition: opacity 1.15s cubic-bezier(0.86,-0.06, 0.23, 0.99);

      @media screen and (max-width: $phone) and (orientation: portrait)
      {
        grid-row-start: 4;
        grid-row-end: 5;
      }

      div
      {
        margin-right: calc(100vh/15);
        margin-top: 16px;

        @media screen and (max-width: $phone) and (orientation: portrait)
        {
          margin-top: 0px;
          margin-right: calc((100vw - 80px) / 10);
        }
      }
    }

    &__frenchTouch
    {
      grid-column-start: 3;
      grid-column-end: 6;
      grid-row-start: 2;
      grid-row-end: 3;
      margin-top: 5%;
      margin-left: -20%;
      display: flex;
      align-items: center;
      position: relative;
      z-index: 2;

      @media screen and (max-width: $phone) and (orientation: portrait)
      {
        margin-top: 0;
        margin-left: 0;
        grid-column-start: 1;
        grid-column-end: 4;
      }

      div
      {
        overflow: hidden;

        @media screen and (max-width: $phone) and (orientation: portrait)
        {
          position: absolute;
          margin-top: 10%;
          margin-left: 16px;
          top: 0;
        }
      }
    }

    &__presentation
    {
      grid-column-start: 4;
      grid-column-end: 5;
      grid-row-start: 3;
      grid-row-end: 4;
      font-size: 20px;
      opacity: 0;
      transition: opacity 1.15s cubic-bezier(0.86,-0.06, 0.23, 0.99);

      @media screen and (max-width: $phone) and (orientation: portrait)
      {
        grid-column-start: 2;
        grid-column-end: 3;
        grid-row-start: 5;
        grid-row-end: 6;
        font-size: 14px;
        margin-top: 16px;
      }

      @media screen and (min-width:$large) {
        width: 80%;
      }

      .internship
      {
        margin-top: 30px;
        margin-bottom: calc(100vh/15);
        font-weight: 500;

          @media screen and (max-width: $phone) and (orientation: portrait)
          {
            margin-top: 20px;
          }
      }
    }
  }

  &__me
  {
    margin-top: 40px;
    margin-left: calc(70px + 100vh/15);
    display: flex;

    @media screen and (max-width: $phone) and (orientation: portrait)
    {
      width: calc(100vw - 80px);
      margin: auto;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &__items
    {
      margin-right: 96px;

      @media screen and (max-width: $phone) and (orientation: portrait)
      {
        margin-right: 0px;
        width: 46%;
      }

      @media screen and (min-width:$large) {
        margin-right: 120px;
      }

      &:last-child
      {
        @media screen and (max-width: $phone) and (orientation: portrait)
        {
          margin-top: 16px;
        }
      }

      .subtitle
      {
        margin-bottom: 16px;
      }

      &__single
      {
        margin-bottom: 25px;
        font-family: 'Din Pro';
        color: #fff;

        @media screen and (max-width: $phone) and (orientation: portrait)
        {
          margin-bottom: 14px;
        }

        &__content
        {
          font-size: 20px;

          @media screen and (max-width: $phone) and (orientation: portrait)
          {
            font-size: 14px;
          }
        }

        &__subtitle
        {
          opacity: 0.3;
          font-size: 16px;
          margin-top: 4px;

          @media screen and (max-width: $phone) and (orientation: portrait)
          {
            font-size: 12px;
          }
        }

        &__link
        {
          font-size: 16px;

          @media screen and (max-width: $phone) and (orientation: portrait)
          {
            font-size: 12px;
          }

          a
          {
            color: #fff;
            position: relative;
            text-decoration: underline;
            transition: 0.4s ease;
            opacity: 0.3;

            &:hover
            {
              opacity: 0.5;
            }
          }
        }
      }
    }
  }

  &__contact
  {
    margin-top: 88px;
    margin-left: calc(70px + 100vh/15);
    margin-bottom: 128px;

    @media screen and (max-width: $phone) and (orientation: portrait)
    {
      width: calc(100vw - 80px);
      margin: 32px auto 32px auto;
    }

    .subtitle
    {
      margin-bottom: 16px;
    }

    &__paragraph
    {
      font-size: 20px;

        @media screen and (max-width: $phone) and (orientation: portrait)
      {
        font-size: 14px;
      }
    }
  }
}

.socials
{
  display: flex;
  position: fixed;
  bottom: 32px;
  right: 70px;

  @media screen and (max-width: $phone) and (orientation: portrait)
  {
    position: relative;
    width: 100%;
    right: 0px;
    bottom: 0;
    justify-content: space-around;
  }

  .paragraph
  {
    margin-right: 40px;
    opacity: 0.2;
    transition:0.4s ease;
    position: relative;

    @media screen and (max-width: $phone) and (orientation: portrait)
    {
      margin-right: 0px;
    }

    .mailCTA
    {
      width:300px;
      text-align:right;
      position:absolute;
      top: -32px;
      right:0px;
      opacity:0;
      transition:0.4s ease;
    }

    &:last-child
    {
      margin-right: 0px;
      cursor: pointer;

      &:hover
      {
        .mailCTA
        {
          opacity:1;
        }

      }
    }

    &:hover
    {
      opacity: 0.6;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/About.vue